import { Card, List } from "antd";
import type { CSSProperties, FC } from "react";
import React, { useEffect } from "react";
import { Remarkable } from 'remarkable';
import style from "../index.less";
import Timeline from "./Timeline";

interface Props { 
    problems: API.codeProblemResult[]; 
    className?: string; 
    style?: CSSProperties 
}
const md = new Remarkable();
/** 编程题结果 */
const CodeResultList: FC<Props> = ({problems}) => {

    return <Card style={{ width: 750, height: 'calc(100vh - 64px - 40px)', margin: '20px auto' }}>
    <div style={{ overflow: 'auto', height: 'calc(100vh - 64px - 84px)' }}>
        <List
            dataSource={problems}
            split={false}
            renderItem={(item) => (
                <List.Item key={item.problemId} style={{ display: 'flex', flexDirection: 'column' }}>
                    {Number.isInteger(item.score) 
                        ? <div style={{ height: 25 }}>{item.num}【{item.score}/25分】</div>
                        : <div style={{ height: 25 }}>{item.num}{item.score + '你'}</div>
                    }
                    <div style={{width: '100%'}} dangerouslySetInnerHTML={{ __html: md.render(item.content) || '' }} />
                    {item.runRecords.length > 0 && <Timeline reply={item.reply} runCodes={item.runRecords}  />}
                    {item.runRecords.length === 0 && <div className={style['code-result']} style={{width: '500px'}} dangerouslySetInnerHTML={{ __html: md.render("```\n" + item.reply +  "\n```") || '' }} />}
                </List.Item>
            )}
        />
    </div>
</Card>;
};

export default CodeResultList;